import { memo } from 'react';
import cls from 'classnames';

import Snackbar from '../Snackbar';

import useStyles from './styles';
import { ISnackbarListProps } from './types';

function SnackbarList({ className, snackItems, onClose }: ISnackbarListProps) {
  const classes = useStyles();

  return snackItems.length ? (
    <div className={cls(classes.root, className)}>
      {snackItems.map((item) => (
        <Snackbar {...item} className={classes.item} key={item.id} onClose={onClose} />
      ))}
    </div>
  ) : null;
}

export default memo(SnackbarList);
